import apiClient from '../apiClient';
import { GET_ALL_SHARED_PACKAGE_URL } from '../apiUrl';

const getAllSharedPackageApi = () => {
  return apiClient.get(GET_ALL_SHARED_PACKAGE_URL);
};

export default getAllSharedPackageApi;
